import { Download, FileText, DollarSign, BarChart3, Receipt, Users, Globe, Sparkles, Star } from "lucide-react";
import { API } from "../lib/apiClient";
import { toast } from "sonner";

const FINANCIAL = [
  { key: "daily-revenue", icon: FileText, title: "Daily Revenue Report", sub: "Room revenue, F&B, extras" },
  { key: "monthly-pnl", icon: DollarSign, title: "Monthly P&L", sub: "Revenue vs expenses" },
  { key: "occupancy-revpar", icon: BarChart3, title: "Occupancy & RevPAR", sub: "ADR, RevPAR, Occ trends" },
  { key: "gst", icon: Receipt, title: "GST / Tax Report", sub: "CGST, SGST, IGST breakup" },
];

const OPERATIONAL = [
  { key: "arrivals-departures", icon: Users, title: "Arrival / Departure List", sub: "Daily guest movement" },
  { key: "channel-performance", icon: Globe, title: "Channel Performance", sub: "Bookings & revenue by OTA" },
  { key: "housekeeping", icon: Sparkles, title: "Housekeeping Status", sub: "Room-wise cleaning log" },
  { key: "feedback", icon: Star, title: "Guest Feedback Report", sub: "Reviews across all platforms" },
];

export default function Reports() {
  function download(key) {
    const token = localStorage.getItem("b4u_token");
    const url = `${API}/reports/${key}?format=csv`;
    // Use fetch with auth header, then blob download
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob())
      .then((blob) => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${key}.csv`;
        a.click();
        toast.success(`${key}.csv downloaded`);
      })
      .catch(() => toast.error("Export failed"));
  }

  return (
    <div className="space-y-10" data-testid="reports-page">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-2">Reports</div>
        <h1 className="font-display text-3xl md:text-4xl">Export insights</h1>
        <p className="text-white/55 text-sm mt-2">Download comprehensive CSV reports for accounting, operations, and analysis.</p>
      </div>

      <Section title="Financial Reports" items={FINANCIAL} onDownload={download} />
      <Section title="Operational Reports" items={OPERATIONAL} onDownload={download} />
    </div>
  );
}

function Section({ title, items, onDownload }) {
  return (
    <div>
      <h2 className="font-display text-2xl mb-5">{title}</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((r) => (
          <div key={r.key} className="bg-[#12182B] border border-white/5 rounded-xl p-6 hover:border-[#D4AF37]/30 transition group" data-testid={`report-${r.key}`}>
            <div className="w-11 h-11 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center text-[#D4AF37] mb-4">
              <r.icon className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <div className="font-display text-lg">{r.title}</div>
            <div className="text-xs text-white/50 mt-1 mb-5">{r.sub}</div>
            <button onClick={() => onDownload(r.key)} className="btn-ghost-gold rounded-md px-3 py-1.5 text-xs inline-flex items-center gap-1.5" data-testid={`export-${r.key}`}>
              <Download className="w-3 h-3" /> Export CSV
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
